var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditContainedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24801 3.16714H4.50926C2.93898 3.16714 1.66602 4.44006 1.66602 6.0103V15.4876C1.66602 17.0578 2.93898 18.3307 4.50926 18.3307H13.9868C15.557 18.3307 16.83 17.0578 16.83 15.4876L16.83 10.7489M6.40476 13.592L9.85298 12.8973C10.036 12.8604 10.2041 12.7703 10.3361 12.6382L18.0553 4.91503C18.4254 4.54475 18.4251 3.94453 18.0547 3.57456L16.4195 1.94126C16.0493 1.57144 15.4493 1.57169 15.0794 1.94183L7.35943 9.66578C7.22768 9.79759 7.13772 9.96533 7.10081 10.148L6.40476 13.592Z",
    stroke: "#6F6F6F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditContainedIcon);
export default __webpack_public_path__ + "static/media/EditContainedIcon.e80a13fbfc1ba8de0d01aa93f1f3c086.svg";
export { ForwardRef as ReactComponent };